const routes = [
    {
        key: "unitsetting",
        name: "科室设置",
        component: () => import("../systemsetting/setting/unitsetting/UnitSettingView"),
    },
];

export default {
    routes,
};
